<template>
    <div id="SysOperationLogList">
        <eb-header>
            <eb-break-crumb slot="breakCrumb" />
        </eb-header>
        <el-form :model="listRequestData" label-width="80px" :inline="true" class="demo-form-inline form">
            <el-form-item label="联系电话">
                <el-input class="eb-input" v-model="listRequestData.userPhone" placeholder="联系电话"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
                <el-input class="eb-input" v-model="listRequestData.trueName" placeholder="真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="机构名称">
                <el-input class="eb-input" v-model="listRequestData.orgName" placeholder="机构名称"></el-input>
            </el-form-item>
            <el-form-item label="请求链接">
                <el-input class="eb-input" v-model="listRequestData.uri" placeholder="请求链接"></el-input>
            </el-form-item>
        </el-form>
        <el-form :model="listRequestData" label-width="80px" :inline="true" class="demo-form-inline">
            <el-form-item label="操作描述">
                <el-input class="eb-input" v-model="listRequestData.description" placeholder="请求参数"></el-input>
            </el-form-item>
            <el-form-item label="请求时间">
                <el-date-picker v-model="listRequestData.requestTimeStart" value-format="yyyy-MM-dd" type="date" placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="-" label-width="6px">
                <el-date-picker v-model="listRequestData.requestTimeEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button class="eb-button-group-btn eb-button-orange button" @click="submitForm">搜索</el-button>
                <el-button class="eb-button-group-btn eb-button-orange button" @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="table eb-table">
            <el-table :data.sync="pageData" tooltip-effect="dark" style="width: 100%" @sort-change="sortChange">
                <el-table-column prop='userPhone' label="联系电话" width="110" sortable="custom"></el-table-column>
                <el-table-column prop='trueName' label="真实姓名" width="100" sortable="custom">
                    <template slot-scope="scope">
                        <a @click="showUserInfo(scope.row)" href="javascript:void(0)" class="a-font-red">{{scope.row.trueName}}</a>
                    </template>
                </el-table-column>
                <el-table-column prop='orgName' label="机构名称" sortable="custom" min-width="130"></el-table-column>
                <el-table-column prop='requestTime' label="请求时间" sortable="custom" min-width="130">
                    <template slot-scope="scope">
                        {{requestTime(scope.row.requestTime)}}
                    </template>
                </el-table-column>
                <el-table-column prop='uri' label="请求链接" sortable="custom" min-width="130"></el-table-column>
                <el-table-column prop='description' label="操作描述" sortable="custom" min-width="130">
                    <template slot-scope="scope">
                        <a @click="showDescription(scope.row)" href="javascript:void(0)" class="a-font-red">{{scope.row.description}}</a>
                    </template>
                </el-table-column>
            </el-table>
            <eb-pagination :current-page.sync="listRequestData.start" v-if="recordsTotal" @current-change="paginationData" :total="recordsTotal" />
        </div>
        <SysOperationDescription />
    </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import SysOperationDescription from '@/pages/sys/SysOperationDescription';
import { getOperationLogs } from '@/services/system-service';
import { clone } from 'lodash';
import eventBus from '@/plugins/event-bus';
import moment from 'moment';
export default {
  name: 'SysOperationLogList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebPagination,
    SysOperationDescription
  },
  data() {
    let startTime = moment()
      .subtract(6, 'days')
      .format('YYYY-MM-DD');
    let endTime = moment().format('YYYY-MM-DD');
    return {
      loading: true,
      pageData: [],
      recordsTotal: null,
      listRequestData: {
        start: 1,
        length: 10,
        orderProp: 'requestTime',
        orderType: 'desc',
        userPhone: '',
        trueName: '',
        orgName: '',
        uri: '',
        description: '',
        requestTimeStart: startTime,
        requestTimeEnd: endTime
      },
      initParams: {}
    };
  },
  created() {
    this.initParams = clone(this.listRequestData);
    this.initOperationLogs();
  },
  methods: {
    async initOperationLogs() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await getOperationLogs(this.listRequestData);
        if (data.returnCode === '01') {
          this.pageData = data.data;
          this.recordsTotal = data.recordsTotal;
        } else {
          this.$message.error('查询用户列表失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
      this.$root.layout.isLoading = false;
    },
    requestTime(time) {
      return this.$options.filters['dateTimeStandardFormat'](time);
    },
    sortChange(columnData) {
      this.listRequestData.orderProp = columnData.prop;
      switch (columnData.order) {
        case 'descending':
          this.listRequestData.orderType = 'desc';
          break;
        case 'ascending':
          this.listRequestData.orderType = 'asc';
          break;
      }
      this.initOperationLogs();
    },
    showUserInfo(row) {
      eventBus.$emit('userInfoDialog', row.userId);
    },
    showDescription(row) {
      eventBus.$emit('showSysOperationDescription', row);
    },
    // 分页
    paginationData(pageNum) {
      this.listRequestData.start = pageNum;
      this.initOperationLogs();
    },
    resetForm: function() {
      this.listRequestData = clone(this.initParams);
      this.initOperationLogs();
    },
    submitForm() {
      this.initOperationLogs();
    }
  }
};
</script>
<style lang="less" scoped>
#SysOperationLogList {
  .form {
    max-width: 100%;
    margin-top: 30px;
  }
  .table {
    padding: 10px 10px;
    max-width: 100%;
    margin-bottom: 20px;
  }
  .button {
    height: 35px;
    width: 80px;
  }
  .a-font-red {
    color: #fb5b3b;
  }
}
</style>
